import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {GritModel, GritOption, GritTableField} from "../../../models/grit/grit.model";
import {MatTable, MatTableModule} from "@angular/material/table";
import {NgFor, NgIf, TitleCasePipe} from "@angular/common";
import {GritDynamicTableMode, GritDynamicTableType} from "../../../models/grit/grit.enums";
import {FormsModule} from "@angular/forms";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {MatCheckboxModule} from "@angular/material/checkbox";

type Row = {
  selected: boolean,
  model: GritModel<any>
}

@Component({
  selector: 'app-grit-dynamic-table',
  templateUrl: './grit-dynamic-table.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: true,
  imports: [MatTableModule, NgFor, NgIf, FormsModule, MatPaginatorModule, MatCheckboxModule],
})
export class GritDynamicTableComponent{
  @Input() type: GritDynamicTableType = GritDynamicTableType.BASIC;
  @Input() mode: GritDynamicTableMode = GritDynamicTableMode.VIEW;
  @Input() pageSize: number = 10;

  @Input({required: true}) entityName : string = "";
  @Input({required: true}) tableConfiguration : GritOption<GritTableField<GritModel<any>>>[]

  @Input() set preSelected(id: number){
    if (id == null) return;
    this.selectedRow = this.rows?.find(row => row.model.id == id)
  }

  dataSource: Row[] = null;
  rows: Row[] = null;

  columns: string[] = null;

  selectedRow: Row = null;
  @Output() selectedRowEvent = new EventEmitter<GritModel<any>>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<any>;

  @Input() set models(models: GritModel<any>[]){
    this.rows = []

    if (models == null || models.length <= 0){
      this.dataSource = models == null ? null : [];
      return;
    }

    if (this.mode > GritDynamicTableMode.SELECT){
      this.columns = ["selected"]
    }
    else{
      this.columns = []
    }

    this.columns.push(...this.tableConfiguration
      .filter(option => option.value.type <= this.type).map(option => option.display))

    this.dataSource = models.map(model => { return {selected: false, model: model}})
    this.pageEvent({pageIndex:0, pageSize:this.pageSize, length:0})
  }

  @Input() set isAllSelected(value : boolean){
    this.dataSource?.forEach(row => row.selected = value);
  }

  get allFeatures() {return this.dataSource?.map(row => row.model)};

  get selectedModels() {return this.dataSource?.filter(row => row.selected)?.map(row => row.model)}

  get isAllSelected(){
    return !this.dataSource.some(row => !row.selected)
  }

  pageEvent(pageEvent: PageEvent){
    let start = pageEvent.pageIndex * pageEvent.pageSize;
    let end = start + pageEvent.pageSize;

    this.rows = this.dataSource.slice(
      start,
      end > this.dataSource.length ? this.dataSource.length : end
    );

    if (this.table){
      this.table.renderRows();
    }
  }

  selectFeature(rowSelected: Row){
    if (this.mode <= GritDynamicTableMode.SELECT ) return;

    else if (this.mode == GritDynamicTableMode.SELECT_ONE){
      this.dataSource.forEach(row => {
        if (row.model.id == rowSelected.model.id){
          row.selected = !row.selected;
        }else{
          row.selected = false;
        }
      })
    }
    else{
      rowSelected.selected = !rowSelected.selected;
    }
  }

  selectRow(row : Row) : void{
    this.selectedRowEvent.emit(row.model)
    if(this.selectedRow?.model.id == row.model.id){
      this.selectedRow = null;
    }else{
      this.selectedRow = row;
    }
  }

  protected readonly GritDynamicTableMode = GritDynamicTableMode;
}
